module.exports = __webpack_public_path__ + "static/media/logo-light.6ede3113.png";